const TOKEN_LOGIN_CREDENTIAL_PARAMS = [
  "token",
  "xeroSimulatorTokenKey",
] as const;

/** Returns a same-origin path without one-use login credentials, when present. */
export const stripTokenLoginCredentialsFromHref = (
  href: string,
): string | null => {
  const url = new URL(href);
  const isTokenLoginRoute =
    url.pathname === "/login" || url.pathname.startsWith("/login/");
  if (!isTokenLoginRoute) return null;

  const hasCredential = TOKEN_LOGIN_CREDENTIAL_PARAMS.some((parameter) =>
    url.searchParams.has(parameter),
  );
  if (!hasCredential) return null;

  for (const parameter of TOKEN_LOGIN_CREDENTIAL_PARAMS) {
    url.searchParams.delete(parameter);
  }

  return `${url.pathname}${url.search}${url.hash}`;
};
